<template>
  <div class="row">
    <h2 class="col-12 mb-4">{{ $t('autocaller_v2.monitoring.operators.topic') }}</h2>
    <div class="col-12 d-flex row">
      <h3 class="col-3 text-muted">{{ operators.length }}</h3>
      <p>{{ $t('autocaller_v2.monitoring.operators.count_active') }}</p>
    </div>
    <div class="col-12 d-flex row">
      <h3 class="col-3 text-success" v-if="operators.length">{{ connected }}</h3>
      <p>{{ $t('autocaller_v2.monitoring.operators.count_connected') }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      operators: {
        type: [Array, String],
        default: () => []
      } 
    },
    computed: {
      connected() {
        return this.operators.filter(function(value) {
          return value.state === 'connected';
        }).length 
      }
    }
  }
</script>